export default "__VITE_ASSET__509c50da__"